import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

const ReviewSlider = () => {
    return (
        <div className="flex items-center justify-center py-[96px] bg-[#F9FAFB] w-full max-2xl:px-[7.7vw] max-w-[1600px]">
            <Swiper pagination={true} loop={true} modules={[Pagination]} className='review__slider'>
                <SwiperSlide className='flex flex-col items-center justify-center gap-[32px] w-full px-[24px]'>
                    <h3 className='text-[36px] font-[500] text-center max-w-[1024px] text-[#101828] max-2xl:text-[32px] max-xl:text-[28px] max-lg:text-[24px] max-sm:text-[20px]'>
                        I was hesitant to sign up at first, but I’m glad I did. Certified DJs has dramatically changed how I manage my gigs. Now, I can take on more events and build my brand without the stress of managing everything alone.
                    </h3>
                    <div className="flex flex-col gap-[16px] items-center">
                        <img src="/images/client2.png" className='object-cover w-[64px] h-[64px]' alt="" />
                        <div className="flex flex-col gap-[4px]">
                            <span className='text-center text-[18px] text-[#101828] font-[600]'>
                                DJ Cooper
                            </span>
                            <span className='text-[#475467]'>
                                Dj at Galactic Rhythms
                            </span>
                        </div>
                        <div className="flex items-center gap-[4px]">
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                        </div>
                    </div>
                </SwiperSlide>
                {/* <SwiperSlide className='flex flex-col items-center justify-center gap-[32px] w-full px-[24px]'>
                    <h3 className='text-[36px] font-[500] text-center max-w-[1024px] text-[#101828] max-2xl:text-[32px] max-xl:text-[28px] max-lg:text-[24px] max-sm:text-[20px]'>
                        Transforming DJ gigs into grand experiences with seamless bookings and all-in-one lifestyle management.
                    </h3>
                    <div className="flex flex-col gap-[16px] items-center">
                        <img src="/images/client1.png" className='object-cover w-[64px] h-[64px]' alt="" />
                        <div className="flex flex-col gap-[4px]">
                            <span className='text-center text-[18px] text-[#101828] font-[600]'>
                                Caitlyn J
                            </span>
                            <span className='text-[#475467]'>
                                Dj at Galactic Rhythms
                            </span>
                        </div>
                        <div className="flex items-center gap-[4px]">
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide className='flex flex-col items-center justify-center gap-[32px] w-full px-[24px]'>
                    <h3 className='text-[36px] font-[500] text-center max-w-[1024px] text-[#101828] max-2xl:text-[32px] max-xl:text-[28px] max-lg:text-[24px] max-sm:text-[20px]'>
                        Transforming DJ gigs into grand experiences with seamless bookings and all-in-one lifestyle management.
                    </h3>
                    <div className="flex flex-col gap-[16px] items-center">
                        <img src="/images/client1.png" className='object-cover w-[64px] h-[64px]' alt="" />
                        <div className="flex flex-col gap-[4px]">
                            <span className='text-center text-[18px] text-[#101828] font-[600]'>
                                Caitlyn J
                            </span>
                            <span className='text-[#475467]'>
                                Dj at Galactic Rhythms
                            </span>
                        </div>
                        <div className="flex items-center gap-[4px]">
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                        </div>
                    </div>
                </SwiperSlide> */}
            </Swiper>
        </div>
    )
}

export default ReviewSlider;